import isApiError from "@insite/client-framework/Common/isApiError";
import {
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { BaseModel} from "@insite/client-framework/Types/ApiModels";
import { GetSizes,GetSizesParameter } from "@tSurya/Services/GetSizesServices";
import { CustomApiHandler } from "@tSurya/Store/CustomHandlerCreator/CustomHandlerCreator";

export interface SizesModel extends BaseModel{
    Sizes:string[];
}

type GetSizsParameterParam = HasOnSuccess<SizesModel> & GetSizesParameter & HasOnError;

type HandlerType = CustomApiHandler<GetSizsParameterParam,SizesModel>;

export const PopulateApiParameter:HandlerType = props=>{
    props.apiParameter = props.parameter;
};

export const RequestDataFromApi : HandlerType = async props =>{
    try{
        props.apiResult = (await GetSizes(props.apiParameter)) as unknown as SizesModel;
        
    } catch(error){
        if (isApiError(error) && error.status === 400) {
            props.parameter.onError?.(error.errorJson.message);
        }
       
        throw error;
    }
};
export const DispatchSizes: HandlerType = props => {
    // const state = props.getState() as unknown as CustomApplicationState;
    // const {
    //     pages: {
    //         productList: { isSearchPage },
    //     },
    // } = state;
    // const prevApiParams: typeof props.apiParameter = { ...props.apiParameter };
    // if(state.SURData.loadMoreDesignerProducts.loadMoreDesignerProducts){
    //     prevApiParams.page =
    //     props.apiParameter.page && props.apiParameter.page > 1
    //         ? props.apiParameter.page - 1
    //         : props.apiParameter.page;
    // }
    // let prevProducts = state.SURData.designerProductsStore.designerProducts;
    // console.log("loadMoreDesignerProducts", state.SURData.loadMoreDesignerProducts.loadMoreDesignerProducts);
    // if (props.apiResult.products && state.SURData.loadMoreDesignerProducts.loadMoreDesignerProducts) {
    //     props.apiResult.products = [...(prevProducts || []), ...props.apiResult.products];
    // } else {
    //     prevProducts = [];
    // }
    
    props.dispatch({
     type:"Custom/Sizes",
     result: props.apiResult,
    })
 }; 
export const ExecuteOnSuccessCallback : HandlerType = props =>{
    if(props.apiResult){

        props.parameter.onSuccess?.(props.apiResult);
        // return props.apiResult;
    }
}

export const chain = [PopulateApiParameter,RequestDataFromApi,DispatchSizes,ExecuteOnSuccessCallback]

const getSizes = createHandlerChainRunner(chain,"GetSizes");
export default getSizes;